import React from 'react';
import {
  Grid,
  makeStyles,
  Typography,
  Collapse,
  Card,
  CardContent,
} from '@material-ui/core';
import { COLORS } from '../../../plTheme';
import { _t_ } from '../../../utils/translation/translation';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { valueMapElements } from '../../../config';

interface CoachingPlanProps {
  activeWeek: number;
  activeQuarter: number;
  repId: string;
  elementObj: any;
  repName: string;
  driver: any;
  timePeriod: string;
  isMultiPage?: boolean;
  pageIndex?: number;
}
const useStyles = makeStyles({
  root: {
    padding: '8px',
    display: 'flex',
    gap: 10,
  },
  outcomesHead: {
    color: COLORS.TEXT_HIGH_EMPHASIS,
    paddingTop: 30,
    paddingBottom: 20,
  },
  outcomeDiv: {
    paddingLeft: '5px ',
  },
  title: {
    height: '32px',
    // width: '159px',
    fontWeight: 500,
    fontSize: '24px',
    // color: '#7E858E',
  },
  item: {
    // height: 480,
  },
  content: { display: 'flex', justifyContent: 'space-between' },
  buttonFont: {
    fontFamily: 'Rubik',
    fontWeight: 500,
    fontSize: 14,
    textTransform: 'none',
  },
  GraphPadding: {
    paddingRight: '50px',
  },
  GraphPadding1: {
    paddingRight: '0px',
  },
  wrapper: {
    display: 'grid',
    gridTemplateRows: '4.5fr 1fr',
    width: '475px',
  },
  wrapper1: {
    display: 'grid',
    gridTemplateRows: '4fr 1fr',
    width: '475px',
  },
  nudgeMessage: {
    lineHeight: '24px',
    fontSize: '18px',
    fontWeight: 300,
  },
  tableMessage: {
    lineHeight: '18px',
    fontSize: '15px',
    fontWeight: 300,
  },
  nudgeHeader: {
    minHeight: '40px',
    width: '630px',
    overflow: 'auto',
    marginBottom: 8,
  },
  avatar: {
    width: 80,
    height: 80,
    fontSize: '30px',
  },
  sectionCard: {
    marginBottom: '16px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  sectionHeader: {
    padding: '16px 14px',
    backgroundColor: '#e8ecefb5',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: '#f1f3f4',
    },
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Rubik',
    color: '#1f2937',
  },
  headerInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '14px 0',
  },
  headerLeft: {
    flex: 1.4,
    marginBottom: 3,
  },
  headerRight: {
    flex: 0.6,
    marginBottom: 2,
    textAlign: 'right',
  },
  infoText: {
    fontSize: '16px',
    fontFamily: 'Rubik',
    color: '#6b7280',
  },
  infoValue: {
    fontSize: '16px',
    fontFamily: 'Rubik',
    color: '#1f2937',
    fontWeight: 400,
  },
});

const CoachingPlan: React.FC<CoachingPlanProps> = ({
  repId,
  elementObj,
  repName,
  driver,
  timePeriod,
  activeWeek,
  activeQuarter,
  isMultiPage = false,
  pageIndex = 0,
}: any) => {
  const classes = useStyles();

  const truncateText = (text: string) => {
    // const wordCount = 26;
    // const words = text.trim().split(/\s+/);
    // if (words.length > wordCount) {
    //   return words.slice(0, wordCount).join(' ') + '...';
    // }
    return `"${
      text.replace(/^'|'$/g, '').split(' ').slice(0, 160).join(' ') + '...'
    }"`;
  };

  const formatPara = (item: string, url: string) => {
    if (!item) return '';
    let openParens = 0;
    let colonIndex = -1;
    let urlTag = '';

    if (url)
      urlTag = `<a href="${url}" target="_blank" rel="noopener noreferrer">[Link]</a>`;

    for (let i = 0; i < item.length; i++) {
      const char = item[i];
      if (char === '(') openParens++;
      else if (char === ')') openParens--;
      else if (char === ':' && openParens === 0) {
        colonIndex = i;
        break;
      }
    }
    if (colonIndex === -1)
      return `${urlTag} <span>${truncateText(item)}</span><br/>`; // no colon found

    const prefix = item.slice(0, colonIndex + 1); // include colon
    const suffix = item.slice(colonIndex + 1).trim();

    return `${truncateText(suffix)}</span><br/>${urlTag} <span>${prefix}`;
  };

  const formatParaNudge = (item: string) => {
    if (!item) return '';
    let openParens = 0;
    let colonIndex = -1;

    for (let i = 0; i < item.length; i++) {
      const char = item[i];
      if (char === '(') openParens++;
      else if (char === ')') openParens--;
      else if (char === ':' && openParens === 0) {
        colonIndex = i;
        break;
      }
    }
    if (colonIndex === -1) return `<span>${item}</span><br/>`; // no colon found

    const prefix = item.slice(0, colonIndex + 1); // include colon
    const suffix = item.slice(colonIndex + 1).trim();

    return `<span><span style="font-weight: 500;">${prefix}</span><br/> ${suffix}</span><br/>`;
  };

  const repScore = elementObj?.['Score (1-10)'] || elementObj?.['Score'];
  const currentEntry =
    elementObj?.['Current Entry'] || elementObj?.['Currrent Entry'];

  const callLogs: any = [
    { id: '005UW000006cZcQYAU', 1: 4, 2: 4, 3: 4, 129: 0 },
    { id: '0055f000008bIEvAAM', 1: 93, 2: 50, 3: 43, 129: 7 },
    { id: '0055f000008bQ2QAAU', 1: 34, 2: 18, 3: 16, 129: 5 },
  ];
  const qtr = activeWeek > -1 ? activeWeek + 100 : activeQuarter;
  let callInfo = callLogs.find((item: any) => item?.id === repId)?.[qtr];
  callInfo = `(${callInfo} calls)`;

  let wdw = elementObj?.['What went well'] || elementObj?.['Whats Done Well'];
  let isColon = wdw?.[0]?.['Well Done']?.includes(':');

  // Define all sections with their data
  const allSections = [
    {
      id: 'wdw',
      title: "What's Done Well (WDW)",
      data: wdw,
      show: wdw?.length > 0,
    },
    {
      id: 'improvementOpportunities',
      title: `Improvement Opportunities (IO) - Discovery - ${valueMapElements[driver]}`,
      data: elementObj?.['Improvement Opportunity'],
      show:
        elementObj?.['Improvement Opportunity'] &&
        (Array.isArray(elementObj['Improvement Opportunity'])
          ? elementObj['Improvement Opportunity'].length > 0
          : true),
    },
    {
      id: 'repNudge',
      title: 'Rep Nudge',
      data: elementObj?.['Rep Nudge'],
      show:
        elementObj?.['Rep Nudge'] &&
        (Array.isArray(elementObj['Rep Nudge'])
          ? elementObj['Rep Nudge'].length > 0
          : true),
    },
    {
      id: 'managerNudge',
      title: 'Manager Nudge',
      data: elementObj?.['Manager Nudge'],
      show:
        elementObj?.['Manager Nudge'] &&
        (Array.isArray(elementObj['Manager Nudge'])
          ? elementObj['Manager Nudge'].length > 0
          : true),
    },
  ];

  // Filter sections that should be shown
  const visibleSections = allSections.filter((section) => section.show);

  const renderSection = (section: any) => {
    switch (section.id) {
      case 'wdw':
        return (
          <Grid item key={section.id}>
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  {section.title}
                  {isColon
                    ? ` - ${wdw?.[0]?.['Well Done']?.split(':')[0]}`
                    : ''}
                </Typography>
              </div>
              <Collapse in={true}>
                <CardContent style={{ padding: 0 }}>
                  <TableContainer>
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell
                            align="left"
                            style={{
                              width: '15%',
                              backgroundColor: '#e8ecefb5',
                              color: '#374151',
                              fontSize: '14px',
                              fontWeight: 600,
                              fontFamily: 'Rubik',
                              border: '1px solid #e5e7eb',
                              padding: '12px 14px',
                            }}
                          >
                            WDW
                          </TableCell>
                          {wdw.map((item: any, index: number) => {
                            const wellDoneText =
                              item?.['Well Done'] || item || '';
                            const columnWidth =
                              wdw.length === 1
                                ? '85%'
                                : wdw.length === 2
                                ? '42.5%'
                                : index < wdw.length - 1
                                ? `${85 / wdw.length}%`
                                : `${
                                    85 -
                                    Math.floor(85 / wdw.length) *
                                      (wdw.length - 1)
                                  }%`;

                            return (
                              <TableCell
                                key={index}
                                align="left"
                                colSpan={wdw.length === 1 ? 6 : 1}
                                style={{
                                  width: columnWidth,
                                  backgroundColor: 'white',
                                  fontSize: '14px',
                                  fontWeight: 400,
                                  fontFamily: 'Rubik',
                                  color: '#374151',
                                  padding: '16px',
                                  border: '1px solid #e5e7eb',
                                  verticalAlign: 'top',
                                }}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    wellDoneText?.split(':')[isColon ? 1 : 0] ||
                                    '',
                                }}
                              />
                            );
                          })}
                        </TableRow>

                        <TableRow>
                          <TableCell
                            align="left"
                            style={{
                              backgroundColor: '#e8ecefb5',
                              fontSize: '14px',
                              fontWeight: 600,
                              color: '#374151',
                              fontFamily: 'Rubik',
                              border: '1px solid #e5e7eb',
                              padding: '12px 14px',
                            }}
                          >
                            Snippet (WDW)
                          </TableCell>
                          {wdw.map((item: any, index: number) => {
                            const lineText =
                              formatPara(
                                item?.['Line'],
                                item?.['Transcript'],
                              ) ||
                              item ||
                              '';
                            const columnWidth =
                              wdw.length === 1
                                ? '85%'
                                : wdw.length === 2
                                ? '42.5%'
                                : index < wdw.length - 1
                                ? `${85 / wdw.length}%`
                                : `${
                                    85 -
                                    Math.floor(85 / wdw.length) *
                                      (wdw.length - 1)
                                  }%`;

                            return (
                              <TableCell
                                key={index}
                                align="left"
                                colSpan={wdw.length === 1 ? 6 : 1}
                                style={{
                                  width: columnWidth,
                                  verticalAlign: 'top',
                                  padding: '16px',
                                  backgroundColor: 'white',
                                  border: '1px solid #e5e7eb',
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: '14px',
                                    color: '#374151',
                                    fontFamily: 'Rubik',
                                    fontWeight: 400,
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: lineText,
                                  }}
                                />
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        );

      case 'improvementOpportunities':
        return (
          <Grid item key={section.id}>
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  {section.title}
                </Typography>
                <div
                    className={classes.infoText}
                    style={{
                      fontSize: 14,
                      fontWeight: 400,
                      fontFamily: 'Rubik',
                      minWidth: 130,
                    }}
                  >
                    <span>Score (1-10): </span>
                    {repScore || 2}
                    <span style={{ margin: '0 2px' }}>→</span>
                    <span>{repScore >= 5 ? 10 : 5}</span>
                  </div>
              </div>
              <Collapse in={true}>
                <CardContent style={{ padding: 0 }}>
                  <TableContainer sx={{ overflowX: 'hidden' }}>
                    <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
                      <TableBody>
                        <TableRow>
                          <TableCell
                            align="left"
                            style={{
                              width: '15%',
                              backgroundColor: '#e8ecefb5',
                              color: '#374151',
                              fontSize: '14px',
                              fontWeight: 600,
                              fontFamily: 'Rubik',
                              border: '1px solid #e5e7eb',
                              padding: '12px 14px',
                            }}
                          >
                            IO
                          </TableCell>
                          {(() => {
                            let improvementOpportunities = section.data || [];
                            return improvementOpportunities.map(
                              (item: any, index: number) => {
                                const improvementText = item || '';
                                const columnWidth =
                                  improvementOpportunities.length === 1
                                    ? '85%'
                                    : improvementOpportunities.length === 2
                                    ? '42.5%'
                                    : index <
                                      improvementOpportunities.length - 1
                                    ? `${85 / improvementOpportunities.length}%`
                                    : `${
                                        85 -
                                        Math.floor(
                                          85 / improvementOpportunities.length,
                                        ) *
                                          (improvementOpportunities.length - 1)
                                      }%`;

                                return (
                                  <TableCell
                                    key={index}
                                    align="left"
                                    colSpan={
                                      improvementOpportunities.length === 1
                                        ? 6
                                        : 1
                                    }
                                    style={{
                                      width: columnWidth,
                                      backgroundColor: 'white',
                                      fontSize: '14px',
                                      fontWeight: 400,
                                      fontFamily: 'Rubik',
                                      color: '#374151',
                                      padding: '12px 14px',
                                      border: '1px solid #e5e7eb',
                                      wordWrap: 'break-word',
                                      overflowWrap: 'break-word',
                                      verticalAlign: 'top',
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: improvementText || '',
                                    }}
                                  />
                                );
                              },
                            );
                          })()}
                        </TableRow>
                        <TableRow>
                          <TableCell
                            align="left"
                            style={{
                              backgroundColor: '#e8ecefb5',
                              fontSize: '14px',
                              fontWeight: 600,
                              color: '#374151',
                              fontFamily: 'Rubik',
                              border: '1px solid #e5e7eb',
                              padding: '12px 14px',
                            }}
                          >
                            Snippet (IO)
                          </TableCell>
                          {(() => {
                            let snippetText = currentEntry || [];
                            return snippetText.map(
                              (item: any, index: number) => {
                                const columnWidth =
                                  snippetText.length === 1
                                    ? '85%'
                                    : snippetText.length === 2
                                    ? '42.5%'
                                    : index < snippetText.length - 1
                                    ? `${85 / snippetText.length}%`
                                    : `${
                                        85 -
                                        Math.floor(85 / snippetText.length) *
                                          (snippetText.length - 1)
                                      }%`;

                                return (
                                  <TableCell
                                    key={index}
                                    align="left"
                                    colSpan={snippetText.length === 1 ? 6 : 1}
                                    style={{
                                      width: columnWidth,
                                      backgroundColor: 'white',
                                      fontSize: '14px',
                                      fontWeight: 400,
                                      fontFamily: 'Rubik',
                                      color: '#374151',
                                      padding: '12px 14px',
                                      border: '1px solid #e5e7eb',
                                      wordWrap: 'break-word',
                                      overflowWrap: 'break-word',
                                      verticalAlign: 'top',
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        formatPara(item.entry, item.url) || '',
                                    }}
                                  />
                                );
                              },
                            );
                          })()}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        );

      case 'repNudge':
        return (
          <Grid item key={section.id}>
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  {section.title}
                </Typography>
              </div>
              <Collapse in={true}>
                <CardContent style={{ padding: 0 }}>
                  <TableContainer sx={{ overflowX: 'hidden' }}>
                    <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            style={{
                              width: '15%',
                              backgroundColor: '#e8ecefb5',
                              color: '#374151',
                              fontSize: '14px',
                              fontWeight: 600,
                              fontFamily: 'Rubik',
                              border: '1px solid #e5e7eb',
                              padding: '12px 14px',
                            }}
                          >
                            Rep Nudge
                          </TableCell>
                          {(() => {
                            let repNudge = section.data || [];
                            return repNudge.map(
                              (nudgeText: string, index: number) => {
                                const columnWidth =
                                  repNudge.length === 1
                                    ? '85%'
                                    : repNudge.length === 2
                                    ? '42.5%'
                                    : index < repNudge.length - 1
                                    ? `${85 / repNudge.length}%`
                                    : `${
                                        85 -
                                        Math.floor(85 / repNudge.length) *
                                          (repNudge.length - 1)
                                      }%`;

                                return (
                                  <TableCell
                                    key={index}
                                    align="left"
                                    style={{
                                      width: columnWidth,
                                      backgroundColor: 'white',
                                      fontSize: '14px',
                                      fontWeight: 400,
                                      fontFamily: 'Rubik',
                                      color: '#374151',
                                      padding: '16px',
                                      border: '1px solid #e5e7eb',
                                      verticalAlign: 'top',
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: formatParaNudge(nudgeText) || '',
                                    }}
                                  />
                                );
                              },
                            );
                          })()}
                        </TableRow>
                      </TableHead>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        );

      case 'managerNudge':
        return (
          <Grid item key={section.id}>
            <Card className={classes.sectionCard}>
              <div className={classes.sectionHeader}>
                <Typography className={classes.sectionTitle}>
                  {section.title}
                </Typography>
              </div>
              <Collapse in={true}>
                <CardContent style={{ padding: 0 }}>
                  <TableContainer sx={{ overflowX: 'hidden' }}>
                    <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="left"
                            style={{
                              width: '15%',
                              backgroundColor: '#e8ecefb5',
                              color: '#374151',
                              fontSize: '14px',
                              fontWeight: 600,
                              fontFamily: 'Rubik',
                              border: '1px solid #e5e7eb',
                              padding: '12px 14px',
                            }}
                          >
                            Manager Nudge
                          </TableCell>
                          {(() => {
                            let managerNudge = section.data || [];
                            return managerNudge.map(
                              (nudgeText: string, index: number) => {
                                const columnWidth =
                                  managerNudge.length === 1
                                    ? '85%'
                                    : managerNudge.length === 2
                                    ? '42.5%'
                                    : index < managerNudge.length - 1
                                    ? `${85 / managerNudge.length}%`
                                    : `${
                                        85 -
                                        Math.floor(85 / managerNudge.length) *
                                          (managerNudge.length - 1)
                                      }%`;

                                return (
                                  <TableCell
                                    key={index}
                                    align="left"
                                    style={{
                                      width: columnWidth,
                                      backgroundColor: 'white',
                                      fontSize: '14px',
                                      fontWeight: 400,
                                      fontFamily: 'Rubik',
                                      color: '#374151',
                                      padding: '16px',
                                      border: '1px solid #e5e7eb',
                                      verticalAlign: 'top',
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: formatParaNudge(nudgeText) || '',
                                    }}
                                  />
                                );
                              },
                            );
                          })()}
                        </TableRow>
                      </TableHead>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        );

      default:
        return null;
    }
  };

  // Return single page structure - Reports component handles page breaks
  return (
    <div
      className={classes.item}
      style={{
        width: '100%',
        maxWidth: '870px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid container direction="column">
        <Grid item>
          <Grid
            container
            direction="row"
            justify="space-between"
            style={{ alignItems: 'center', margin: '8px 0px 8px 0px' }}
          >
            <Grid item>
              <Typography variant="h3" className={classes.title}>
                {isMultiPage && pageIndex > 0
                  ? _t_(`Coaching Plan - ${repName.split(' ')[0]} (Continued)`)
                  : _t_(`Coaching Plan - ${repName.split(' ')[0]}`)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Show header info on all pages with consistent format */}
        <Grid style={{ height: 44, marginBottom: '10px' }}>
          <div className={classes.headerInfo}>
            <div className={classes.headerLeft}>
              <div className={classes.infoValue} style={{ marginBottom: 5 }}>
                <span className={classes.infoValue}>Account / Deal:</span>{' '}
                {`All Deals ${callInfo}`}
              </div>
              {/* <div className={classes.infoValue}>
                <span className={classes.infoValue}>Focus Area:</span> Discovery
                - {valueMapElements[driver]}
              </div> */}
            </div>
            <div className={classes.headerRight}>
              <div className={classes.infoValue} style={{ marginBottom: 5 }}>
                <span className={classes.infoValue}>Time Period:</span>{' '}
                {timePeriod?.match(/\(([^)]+)\)/)?.[1] ?? timePeriod}
              </div>
              {/* <div className={classes.infoValue}>
                <span className={classes.infoValue}>Score (1-10):</span>{' '}
                {repScore || 2} → {repScore > 5 ? 10 : 5}
              </div> */}
            </div>
          </div>
        </Grid>

        <div style={{ flex: 1, paddingTop: '10px' }}>
          {visibleSections.map((section) => renderSection(section))}
        </div>
      </Grid>
    </div>
  );
};

export default CoachingPlan;
